import { render } from "./LetsTalkBlock.vue?vue&type=template&id=3525138e&scoped=true"
import script from "./LetsTalkBlock.vue?vue&type=script&lang=js"
export * from "./LetsTalkBlock.vue?vue&type=script&lang=js"

import "./LetsTalkBlock.vue?vue&type=style&index=0&id=3525138e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3525138e"]])

export default __exports__